import Swal from "sweetalert2";

export const NO_MANAGER_MESSAGE =
  "You cannot apply for leave because no manager is assigned to you. Please contact HR.";

export function parseLeaveResult(data) {
  try {
    if (!data) return {};
    if (typeof data.result === "string") return JSON.parse(data.result);
    return data.result || data;
  } catch (e) {
    return {};
  }
}

export function isNoManagerMessage(message) {
  return (message || "").toLowerCase().includes("no manager");
}

export function showLeaveError(message) {
  const msg = message || NO_MANAGER_MESSAGE;
  const isNoManager = isNoManagerMessage(msg);
  Swal.fire({
    icon: isNoManager ? "warning" : "error",
    title: isNoManager ? "Cannot Apply Leave" : "Error",
    text: msg,
    confirmButtonColor: "#875A7B",
  });
}

export function showLeaveCatch(error) {
  Swal.fire({
    icon: "error",
    title: "Error",
    text: error?.message || "Something went wrong. Please try again.",
    confirmButtonColor: "#875A7B",
  });
}
